
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import React from "react";
import { currency } from "../../../MUI_components/currencyFormatterTag";
import FormControl from "Components/MUI_components/FormControl/fomikFormControl";
import { Field } from "formik";
import { NumFormat } from "Components/MUI_components/currencyFormat";

export default function ReturnDataTable(props: any) {
  const { data, returnedDiscount, setReturnedDiscount } = props;


  const lineTotalAmt = data.map((props: any) => props.totalAmount);

  const subTotalAmount = lineTotalAmt.reduce((totalAmount: number, i: number) => totalAmount + i, 0);
  
  const totalAmount = subTotalAmount - returnedDiscount;
  



  return (
    <Paper style={{ padding: 10 }}>
      {data.length ? (
        <TableContainer>
          <Table size="small" aria-label="spanning table">
            <TableHead style={{ backgroundColor: "#cacaca50" }}>
              <TableRow>
                <TableCell align="center" colSpan={5}>
                  Details
                </TableCell>
                <TableCell align="right">Price</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="5">#</TableCell>
                <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                <TableCell align="right">{COLUMNS_NAME.DESCRIPTION}</TableCell>
                <TableCell align="right">{COLUMNS_NAME.UNIT_SOLD_PRICE}</TableCell>
                <TableCell align="right">{COLUMNS_NAME.DISCOUNT}</TableCell>
                <TableCell align="right">{COLUMNS_NAME.TOTAL_AMOUNT}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any, index: number) => (
                <TableRow key={index}>
                  <TableCell width="5">{index + 1}</TableCell>
                  <TableCell>{row.itemMaster.name ? row.itemMaster.name : row.item.name}</TableCell>
                  <TableCell align="right">{row.quantity}</TableCell>
                  {/* <TableCell align="right">{row.unitSoldPrice}</TableCell> */}
                  <TableCell align="right">{currency(row.totalAmount / row.quantity)}</TableCell>
                  <TableCell align="right">{currency(row.discount)}</TableCell>
                  <TableCell align="right">{currency(row.totalAmount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              {data.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    No Data
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  <TableRow>
                    <TableCell colSpan={4} />
                    <TableCell>{COLUMNS_NAME.SUB_TOTAL}</TableCell>
                    <TableCell align="right">{currency(subTotalAmount)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4} />
                    <TableCell>{COLUMNS_NAME.DISCOUNT}</TableCell>
                    <TableCell align="right">

                      <input
                        type="number"
                        style={{
                          fontSize: 12,
                          width: props.width ? props.width : 50,
                          maxWidth: 200,
                        }}
                        value={returnedDiscount}
                        onChange={(e: any) =>
                          props.handleDiscountChange(e)
                        }
                        className="custom-input"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4} />
                    <TableCell>{COLUMNS_NAME.TOTAL}</TableCell>
                    <TableCell align="right">{currency(totalAmount)}</TableCell>
                  </TableRow>
                </>
              )}
            </TableHead>
          </Table>
        </TableContainer>
      ) : (
        <div
          className="flex justify-content-center fullWidth "
          style={{
            padding: 30,
          }}
        >
          {data === null ? "Invoice not found" : "No Data"}
        </div>
      )}
    </Paper>
  );
}
